import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { propTypes } from '../../util/types';
import { resolveLatestProcessName, getProcess } from '../../transactions/transaction';
import { types as sdkTypes } from "../../util/sdkLoader";

import css from './OrderBreakdown.module.css';
import { TRANSACTION_PAGE } from '../../util/constant';

const { Money } = sdkTypes;

const LineItemTotalPrice = props => {
  const { transaction, isProvider, intl, isCustomer, currentPage } = props;
  const processName = resolveLatestProcessName(transaction?.attributes?.processName);
  if (!processName) {
    return null;
  }
  const process = getProcess(processName);
  const isCompleted = process.isCompleted(transaction?.attributes?.lastTransition);
  const isRefunded = process.isRefunded(transaction?.attributes?.lastTransition);

  let providerTotalMessageId = 'OrderBreakdown.providerTotalDefault';
  if (isCompleted) {
    providerTotalMessageId = 'OrderBreakdown.providerTotalReceived';
  } else if (isRefunded) {
    providerTotalMessageId = 'OrderBreakdown.providerTotalRefunded';
  }

  const totalLabel = isProvider ? (
    <FormattedMessage id={providerTotalMessageId} />
  ) : (isCustomer && currentPage == TRANSACTION_PAGE) ? (
    <FormattedMessage id={"OrderBreakdown.customerTotalShow"} />
  ) : (
    // <FormattedMessage id="OrderBreakdown.total" />
    <FormattedMessage id="LineItemDepositePriceMaybe.depositeMoneyLabel" />
  );

  const totalPrice = isProvider
    ? transaction.attributes.payoutTotal
    : transaction.attributes.payinTotal;
  const formattedTotalPrice = formatMoney(intl, totalPrice);
  const formattedDepositePrice = formatMoney(intl, new Money((totalPrice.amount), totalPrice.currency));

  return (
    <>
      <hr className={css.totalDivider} />
      <div className={css.lineItemTotal}>
        <div className={css.totalLabel}>{totalLabel}</div>
        <div className={css.totalPrice}>{(isCustomer && currentPage == TRANSACTION_PAGE) ? formattedDepositePrice : formattedTotalPrice}</div>
      </div>
    </>
  );
};

LineItemTotalPrice.propTypes = {
  transaction: propTypes.transaction.isRequired,
  isProvider: bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemTotalPrice;
